import { UserContext } from "../Definitions/UserContext";
import { AsyncAjaxGet } from "./AsyncAjaxService";
import { ValidateToken } from "./BusinessData";

const VagaroAPIEnum = {

    getLocationFromSearch: "Merchants/mysite/getbusinesslocationsearch",
    getPlace: "google/json?Type=place&",
    getGeocode: "google/json?Type=geocode&"

}


export async function GetLocationsFromSearch(userContext: UserContext, searchString: string, onComplete: (data: any) => void, onError: (error: any) => void) {

    await ValidateToken(userContext);

    let url = VagaroAPIEnum.getLocationFromSearch + "?input=" + searchString;

    await AsyncAjaxGet(url, userContext.accessToken, onComplete, onError);
}

export async function GetLocationPlace(userContext: UserContext, placeId: string, onComplete: (data: any) => void, onError: (error: any) => void) {

    await ValidateToken(userContext);

    let url = VagaroAPIEnum.getPlace + "placeid=" + placeId;

    await AsyncAjaxGet(url, userContext.accessToken, onComplete, onError);
}

export async function GetLocationFromLatLon(userContext: UserContext, lat: string, lon: string, onComplete: (data: any) => void, onError: (error: any) => void) {

    await ValidateToken(userContext);

    let url = VagaroAPIEnum.getGeocode + "lat=" + lat + "&lon=" + lon + "&radius=25";

    await AsyncAjaxGet(url, userContext.accessToken, onComplete, onError);
}